import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext.js';
import { AppLayout } from '../components/AppLayout.js';
import { AdminOffers } from './offers/AdminOffers.js';
import { CustomerOffers } from './offers/CustomerOffers.js';

/**
 * /offers — RFQ/piedāvājumu lapa, lomu-apzinīga (§4.9):
 * platforma komponē/salīdzina/nosūta (pilna marža redzama);
 * klients pieprasa cenu un apstiprina projicēto piedāvājumu (kategorijas + gala cena).
 */

function isPlatformRole(role: string): boolean {
  return role.startsWith('platform_') || role === 'auditor';
}

export default function Offers() {
  const { t } = useTranslation('offers');
  const { user } = useAuth();
  const platform = user ? isPlatformRole(user.role) : false;

  return (
    <AppLayout title={t('title')}>{platform ? <AdminOffers /> : <CustomerOffers />}</AppLayout>
  );
}
